class tooltips {
	constructor() {

	}
	enable(el) {
		$(el).on('shown.bs.tooltip', () => {
			let copyIcon = $(el.querySelector('.tooltip-copy'));
			let twitterIcon = $(el.querySelector('.tooltip-twitter'));
			let emailIcon = $(el.querySelector('.tooltip-email'));
			copyIcon.on('click', this.copyClickHandle);
			twitterIcon.on('click', this.twitterClickHandle);
			emailIcon.on('click', this.emailClickHandle);
		});
		$(el).tooltip();
	}
	copyClickHandle(ev) {
		const info = window.app.tooltips.gatherBasicInformation(this);
		info.link.select();
		document.execCommand('copy');
		alert('Content is on your clipboard!');
	}
	twitterClickHandle(ev) {
		const info = window.app.tooltips.gatherBasicInformation(this);
		const twitterIntentUrl = 'https://twitter.com/intent/tweet/';
		const intentURI = `${twitterIntentUrl}?text=${encodeURIComponent(info.highlightContentInput.value)}&url=${encodeURIComponent(window.location.href)}`;
		window.open(intentURI, 'twitterwindow', 'height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
	}
	emailClickHandle(ev) {
		const info = window.app.tooltips.gatherBasicInformation(this);
		const mailto = `mailto:?subject=${encodeURIComponent('The Heroic Journey of Teenagers')}&body=${encodeURIComponent(
			`${info.highlightContentInput.value}\n\n${window.location.href}`
		)}`;
		window.open(mailto, '_self');
	}
	gatherBasicInformation(el) {
		return ((tooltipContainer) => {
			return {
				tooltipContainer: tooltipContainer,
				highlightContentInput: tooltipContainer.querySelector('[role="contentinfo"]'),
				link: tooltipContainer.querySelector('[role="link"]')
			};
		})(window.app.tooltips.determineParent(el));
	}
	determineParent(el) {
		return el.parentNode.parentNode;
	}
}

window.app.add('tooltips', new tooltips());